import { render, staticRenderFns } from "./products-addcats.vue?vue&type=template&id=7dade2f8"
import script from "./products-addcats.vue?vue&type=script&lang=js"
export * from "./products-addcats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports